module.exports = __webpack_public_path__ + "static/media/credit-card.ed15d0b7.svg";